<template> 
    <base-card id="cardQuizAdvice" :title="$t('completeYourHealthProfile')">
        <div class="mb-3" v-html="$t('fillQuizAdvice')"></div>
        <div>
            <base-button white class="mt-3" @click="goToSection(QUIZ_PATH)">{{ $t('complete') }}</base-button>
            <base-button class="mt-3" :backgroundColor="BACKGROUND_COLOUR" :textColor="GRAY_COLOUR" :borderColor="BACKGROUND_COLOUR" @click="remindLater()">{{ $t('later') }}</base-button>
        </div>
    </base-card>
</template>

<script>
import BaseCard from '@/components/base/ui/BaseCard.vue'
import BaseButton from '@/components/base/buttons/BaseButton'
import { BACKGROUND_COLOUR, GRAY_COLOUR } from '@/constants/colours'
import { QUIZ_PATH } from '@/constants/clinicHistory'
import clinicHistoryMixin from '@/mixins/clinicHistory.mixin'

export default {
    components: {
        BaseCard,
        BaseButton
    },
    props: {
    },
    mixins: [clinicHistoryMixin],
    data () {
        return {
            QUIZ_PATH,
            BACKGROUND_COLOUR,
            GRAY_COLOUR
        }
    },
    created () {
    },
    methods: {
        remindLater () {
            // reminder in 1 month
            let reminderDate = new Date(new Date().setMonth(new Date().getMonth() + 1))
            localStorage.setItem('remindQuizDate', reminderDate)
            this.$emit('remindLaterSelected')
        }
    },
    computed: {
    }
}
</script>

<style lang="scss">
#cardQuizAdvice{
    background-color: $green;
    border-color: $green;
    @include media(mobile) {
        .btn{
            padding: .6rem 1.1rem
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/components/views/clinicHistory/quiz/ClinicHistoryFillQuizAdvice.vue